var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.15,
    height: 29.738,
    viewBox: "0 0 29.15 29.738",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4285f4;}.b{fill:#34a853;}.c{fill:#fbbc04;}.d{fill:#ea4335;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.05 0.018)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M286.381,226.121a17.489,17.489,0,0,0-.257-3.021H272.1v5.726h8.031a6.882,6.882,0,0,1-2.972,4.518v3.715h4.791A14.521,14.521,0,0,0,286.381,226.121Z",
    transform: "translate(-257.281 -210.928)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M42.187,336.32a14.233,14.233,0,0,0,9.856-3.589l-4.791-3.715A9.018,9.018,0,0,1,33.844,324.3H28.9v3.83A14.871,14.871,0,0,0,42.187,336.32Z",
    transform: "translate(-27.368 -306.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M6.471,159.523a8.906,8.906,0,0,1,0-5.693V150H1.532a14.881,14.881,0,0,0,0,13.353Z",
    transform: "translate(0 -141.822)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M42.187,5.867a8.08,8.08,0,0,1,5.7,2.229h0l4.245-4.245A14.29,14.29,0,0,0,42.187-.017,14.866,14.866,0,0,0,28.9,8.178l4.939,3.83A8.894,8.894,0,0,1,42.187,5.867Z",
    transform: "translate(-27.368 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGoogle);
export default __webpack_public_path__ + "static/media/logo-google.b3b19047fb004a9753e8486acee877c5.svg";
export { ForwardRef as ReactComponent };